/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DomainDNSConfig = {
  /**
   * The static IP addresses apex custom domains should point A records at
   */
  aRecords: Array<string>;
  /**
   * The CNAME target subdomain custom domains should point at, if configured
   */
  cnameTarget?: string | undefined;
};

/** @internal */
export const DomainDNSConfig$inboundSchema: z.ZodMiniType<
  DomainDNSConfig,
  unknown
> = z.pipe(
  z.object({
    a_records: z.array(z.string()),
    cname_target: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "a_records": "aRecords",
      "cname_target": "cnameTarget",
    });
  }),
);

export function domainDNSConfigFromJSON(
  jsonString: string,
): SafeParseResult<DomainDNSConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DomainDNSConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DomainDNSConfig' from JSON`,
  );
}
